import React, { useState, useEffect } from 'react'
import { Row, Col, List, Upload, message as alert, Button as AntButton } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { getProduct, uploadProductFile, deleteProductFile } from '../../redux/slices/productsSlice'
import { ButtonComponent as Button } from '../../components'
import { ReactComponent as iconDownload } from '../../assets/img/download.svg'
import { InboxOutlined, DeleteOutlined } from '@ant-design/icons'
import { downloadFile } from '../../utils/functions'

const { Dragger } = Upload

const ProductFiles = ({ productId }) => {
    const dispatch = useDispatch()
    const { product, isSubmit } = useSelector(state => state.products)
    const [uploading, setUploading] = useState(false)

    const handleDownload = (file) => {
        if (file.url) {
            // Se já temos uma URL, usar diretamente
            const link = document.createElement('a')
            link.href = file.url
            link.target = '_blank'
            link.download = file.nome || file.name || 'download'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        } else if (file.path || file.id) {
            // Se temos um path ou id, usar a função downloadFile existente
            downloadFile(file.path || file.id)
        }
    }

    useEffect(() => {
        if (productId) {
            dispatch(getProduct({ id: productId }))
        }
    }, [dispatch, productId])

    const handleUpload = async (file) => {
        try {
            setUploading(true)
            await dispatch(uploadProductFile({ productId, file })).unwrap()
            alert.success('Arquivo enviado com sucesso!')
            // Recarregar produto para atualizar lista de arquivos
            dispatch(getProduct({ id: productId }))
        } catch (error) {
            alert.error(error || 'Erro ao fazer upload do arquivo')
        } finally {
            setUploading(false)
        }
        return false // Prevenir upload automático
    }

    const handleDelete = async (fileId) => {
        try {
            await dispatch(deleteProductFile({ fileId })).unwrap()
            alert.success('Arquivo removido com sucesso!')
            // Recarregar produto para atualizar lista de arquivos
            dispatch(getProduct({ id: productId }))
        } catch (error) {
            alert.error(error || 'Erro ao remover arquivo')
        }
    }

    const uploadProps = {
        beforeUpload: handleUpload,
        showUploadList: false,
        multiple: false
    }

    const files = product?.files || []

    return (
        <div>
            <Row>
                <Col md={24}>
                    <h3 className="tx-pink font-bold">Arquivos do Produto</h3>
                </Col>
                <Col md={24} className="mt-15">
                    <Dragger {...uploadProps} disabled={uploading}>
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">Clique ou arraste arquivo para esta área para fazer upload</p>
                        <p className="ant-upload-hint">
                            Suporte para upload de um único arquivo
                        </p>
                    </Dragger>
                </Col>
                <Col md={24} className="mt-25">
                    {files.length > 0 ? (
                        <List
                            dataSource={files}
                            renderItem={(file) => (
                                <List.Item
                                    actions={[
                                        <Button
                                            key="download"
                                            type="primary"
                                            icon={iconDownload}
                                            onClick={() => handleDownload(file)}
                                        >
                                            Download
                                        </Button>,
                                        <AntButton
                                            key="delete"
                                            danger
                                            icon={<DeleteOutlined />}
                                            onClick={() => handleDelete(file.id)}
                                            loading={isSubmit}
                                        >
                                            Remover
                                        </AntButton>
                                    ]}
                                >
                                    <List.Item.Meta
                                        title={file.nome || file.name || `Arquivo ${file.id}`}
                                        description={file.tipo || file.type || 'Sem tipo especificado'}
                                    />
                                </List.Item>
                            )}
                        />
                    ) : (
                        <p className="tx-gray">Nenhum arquivo adicionado ainda</p>
                    )}
                </Col>
            </Row>
        </div>
    )
}

export default ProductFiles
